import { Injectable, signal, WritableSignal } from '@angular/core';
import { FeatureCollection } from 'geojson';
import { Filter } from '../../domain/interfaces/Filter.interface';

@Injectable({
  providedIn: 'root',
})
export class FilterSignalService {

  alertsSelected: WritableSignal<{
    features?: FeatureCollection;
    fitOn?: boolean;
    latLng?: { lat: number; lng: number };
  }> = signal<{
    features?: FeatureCollection;
    fitOn?: boolean;
    latLng?: { lat: number; lng: number };
  }>({});
  isZoomChecked: WritableSignal<boolean> = signal<boolean>(false);
  alertId: WritableSignal<string> = signal<string>('');
  filter: WritableSignal<Filter> = signal<Filter>({});
  alertVisibility: WritableSignal<boolean> = signal<boolean>(true);
  filterChanged: WritableSignal<boolean> = signal<boolean>(false);

  setFilter(filter: Filter) {
    this.filter.set(filter);
  }
}
